export default {
  title: 'Pasarela de pago',
  description:
    'Tus propias pasarelas de pago para pedidos en línea. El importe total del pedido se liquida en tu cuenta de la pasarela; tú liquidas con tus restaurantes.',
  toasts: {
    load_error: 'No se pudo cargar la configuración de la pasarela',
  },
  not_enabled: {
    title: 'Spreedly aún no está activado para tu cuenta',
    description:
      'Las pasarelas de pago locales son activadas por FoodAmigos. Contacta a tu representante de FoodAmigos para empezar.',
  },
  processor_mode: {
    title: '¿Quién procesa los pagos?',
    description:
      'Esto se configura una vez para todos tus restaurantes. Puedes cambiarlo más tarde en Configuración de socio mientras ningún restaurante esté activo.',
    save: 'Guardar',
    options: {
      platform: {
        title: 'FoodAmigos procesa los pagos',
        badge: 'Recomendado',
        description:
          'Nosotros gestionamos la cuenta de pago, la verificación y los pagos. Cada restaurante añade sus datos comerciales y completa una breve verificación con Adyen.',
        methods: 'Aceptados: {{methods}}',
      },
      provider: {
        title: 'Uso mi propio proveedor',
        description:
          'Conecta un proveedor de pagos que ya utilizas. Los pagos, las comisiones y la verificación se quedan con ellos.',
      },
    },
    payment_methods: {
      card: 'Tarjeta',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Pago por banco',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos procesa los pagos de todos tus restaurantes.',
      provider: 'Tus restaurantes reciben pagos a través de tus propios proveedores.',
    },
    confirm_choice: {
      title: '¿Configurar los pagos en “{{mode}}”?',
      description:
        'Esto se aplica a todos los restaurantes que gestionas. Puedes cambiarlo más tarde en Configuración de socio, pero solo mientras ningún restaurante esté activo.',
      confirm: 'Guardar y continuar',
    },
    switch: {
      link: 'Cambiar cómo se procesan los pagos',
      confirm: {
        confirm: 'Cambiar',
        provider: {
          title: '¿Cambiar a tu propio proveedor?',
          description: 'Los restaurantes que usan pagos de FoodAmigos volverán a No configurado.',
        },
        platform: {
          title: '¿Cambiar a pagos de FoodAmigos?',
          description: 'Los restaurantes que usan tus propios proveedores volverán a No configurado.',
        },
      },
      unavailable: {
        title: 'Los pagos de FoodAmigos aún no están disponibles',
        description: 'Los pagos de FoodAmigos aún no están disponibles en tu país.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Contacta a FoodAmigos para cambiar esto',
        description_one:
          '{{count}} restaurante está recibiendo pagos en vivo. Cambiar implicaría que se incorpore de nuevo con el nuevo proveedor. Nuestro equipo lo planificará contigo.',
        description_other:
          '{{count}} restaurantes están recibiendo pagos en vivo. Cambiar implicaría que se reincorporen con el nuevo proveedor. Nuestro equipo lo planificará contigo.',
        confirm: 'Enviar correo a FoodAmigos',
        subject_one: 'Cambiar cómo se procesan los pagos ({{count}} restaurante en vivo)',
        subject_other: 'Cambiar cómo se procesan los pagos ({{count}} restaurantes activos)',
      },
    },
    toasts: {
      load_error: 'Error al cargar la configuración de pagos',
      save_error: 'Error al guardar la configuración de pagos',
      chosen: 'Procesamiento de pagos guardado',
      switched: 'Procesamiento de pagos cambiado',
    },
  },
  gateways: {
    title: 'Proveedores conectados',
    empty: 'Conecta el proveedor de pago que ya utilizas. Tus restaurantes se incorporarán bajo este.',
    connect_another: 'Conectar un proveedor',
    support_hint:
      'Una vez que un restaurante esté procesando pagos en vivo, el cambio de proveedor se planifica con nosotros: escribe a {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Pasarela de pago',
      platform_adyen: 'Pagos de FoodAmigos',
    },
    statuses: {
      connected: 'Conectado',
      disconnected: 'Desconectado',
      needs_attention: 'Requiere atención',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect no está activado en la cuenta de {{name}}',
        description:
          'Stripe no puede crear cuentas para tus restaurantes hasta que se active Connect. Actívalo en tu panel de Stripe y vuelve a comprobarlo aquí.',
      },
      account_restricted: {
        title: 'Stripe está reteniendo las cuentas nuevas de {{name}}',
        description:
          'Stripe ha restringido temporalmente tu cuenta para crear cuentas conectadas. Inicia sesión en tu panel de Stripe, confirma que querías crear estas cuentas y vuelve a comprobarlo aquí.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe necesita que {{name}} acepte primero la responsabilidad por pérdidas',
        description:
          'Tu plataforma de Stripe aún no ha aceptado la responsabilidad por los saldos negativos en las cuentas de tus restaurantes, por lo que Stripe no las creará. En tu Panel de Stripe, abre Configuración → Connect → Perfil de la plataforma y completa la aceptación de la responsabilidad por pérdidas; después vuelve a comprobarlo aquí. Puedes ignorar la nota de Stripe sobre Accounts v2 que aparece más abajo.',
      },
      account_creation_refused: {
        title: 'Stripe se ha negado a crear una cuenta de restaurante en {{name}}',
        description: 'Revisa el mensaje de abajo en tu panel de Stripe y vuelve a comprobarlo aquí.',
      },
      key_invalid: {
        title: 'Stripe ya no acepta la clave que conectaste para {{name}}',
        description:
          'La clave fue renovada, revocada o ha caducado. Crea una nueva clave en tu panel de Stripe y sustitúyela aquí.',
      },
      key_access_limited: {
        title: 'Stripe ha limitado la clave que conectaste para {{name}}',
        description:
          'Una clave limitada no puede crear transferencias ni pagos para tus restaurantes. En tu panel de Stripe, abre Developers → API keys y restablece el acceso completo de la clave, luego vuelve a comprobarlo aquí — o rota la clave y sustitúyela aquí.',
      },
      provider_said: 'Lo que ha dicho Stripe: «{{message}}»',
      hint: 'Hasta que se resuelva, los restaurantes vinculados a este proveedor no pueden empezar a aceptar pagos en línea.',
      open_stripe: 'Abrir panel de Stripe',
      check_again: 'Comprobar de nuevo',
      replace_key: 'Reemplazar clave',
      cleared: 'Stripe vuelve a aceptar tus restaurantes',
      still_blocked: 'Stripe sigue rechazándolo: consulta arriba lo que ha dicho',
    },
    refused: {
      provider_said: 'Lo que {{name}} dijo: «{{message}}»',
      reference: 'Referencia:',
      contact_support: 'Enviar correo a soporte',
      support_subject: 'Conexión del proveedor de pago rechazada: {{name}} (ref {{reference}})',
      account_in_test_mode: {
        action: 'Desactiva el Modo de Prueba en Authorize.Net, en {{path}}, y vuelve a intentarlo.',
        open: 'Abrir Authorize.Net',
      },
      processor_not_configured: {
        action:
          'Llame a su proveedor de servicios comerciales, la empresa que abrió su cuenta de Authorize.Net, y pídales que finalicen su configuración con el procesador de pagos. Las nuevas claves no cambiarán esto. Luego vuelva a intentarlo.',
        action_card_connect:
          'Pida al soporte de CardConnect que habilite las autorizaciones sin tarjeta presente (comercio electrónico) en este ID de comercio. Las nuevas credenciales de API no lo cambiarán. Después, inténtelo de nuevo.',
      },
    },
    table: {
      primary_tag: 'Predeterminado',
      live_count_one: '{{count}} procesando pagos',
      live_count_other: '{{count}} procesando pagos',
      attention_count_one: '{{count}} necesita atención',
      attention_count_other: '{{count}} necesitan atención',
      columns: {
        connection: 'Proveedor',
        status: 'Estado',
        restaurants: 'Restaurantes',
        methods: 'Métodos locales',
      },
      methods_count: '{{enabled}} de {{capable}} activos',
    },
    picker: {
      recommended: 'Recomendado',
      connect: 'Conectar',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Usa tu propia cuenta de Stripe. Cada restaurante completa el proceso de incorporación propio de Stripe; los pagos y las comisiones permanecen con Stripe.',
        already_connected: 'Ya está conectado. Usa Editar credenciales en la lista para reemplazar su clave.',
        already_connected_short: 'Ya conectado.',
      },
      stripe_direct: {
        title: 'Stripe (directo)',
        description: 'Cobra a todos los restaurantes a través de una sola cuenta de Stripe tuya.',
        unavailable: 'Aún no disponible en tu región.',
      },
      paypal: {
        direct: 'Ofrece PayPal desde tu propia cuenta empresarial de PayPal.',
        braintree: 'Acepta tarjetas, PayPal y Venmo a través de tu cuenta de Braintree.',
      },
      other: {
        title: 'Otros proveedores',
        search: 'Buscar proveedores',
        loading: 'Cargando proveedores…',
        no_match: 'Ningún proveedor llamado «{{query}}».',
        none_available: 'Aún no hay otros proveedores disponibles en tu región.',
        load_error: 'No se pudo cargar la lista de proveedores.',
        retry: 'Intentar de nuevo',
        pinned_match: 'Ese proveedor está fijado arriba.',
      },
      not_listed: {
        action: 'Mi proveedor no aparece en la lista',
        subject: 'Solicitud de proveedor de pagos: {{query}}',
      },
      use_foodamigos: {
        no_account: 'No tengo cuenta en ninguno de estos',
        switch: 'Cambiar a pagos de FoodAmigos',
      },
    },
    orchestrated: {
      title: 'Conectar {{name}}',
      replace_title: 'Reemplazar las credenciales de {{name}}',
      intro: 'Ingresa las credenciales de tu cuenta de {{name}}. Las verificamos con {{name}} antes de guardar nada.',
      auth_mode: 'Cómo inicias sesión en este proveedor',
      checking: 'Verificando con {{name}}…',
      paypal_direct: {
        intro:
          'Pega el Client ID y el Secret de la app REST de PayPal con la que tus restaurantes deben aceptar PayPal. Los verificamos con PayPal antes de guardar nada.',
        client_id: 'Client ID',
        secret: 'Secret',
        hint: 'Panel de desarrolladores de PayPal → Apps & Credentials, en la pestaña Live. Usa una app REST de tu cuenta comercial.',
        hint_sandbox:
          'Panel de desarrollador de PayPal → Apps y credenciales, en la pestaña Sandbox: este entorno solo admite apps de sandbox.',
      },
      braintree: {
        intro:
          'Introduce las claves de API de tu cuenta de Braintree. PayPal y Venmo funcionan una vez vinculados en tu Panel de Control de Braintree — los activas por conexión después.',
      },
      authorize_net: {
        intro:
          'Introduce el ID de inicio de sesión de API y la clave de transacción de tu cuenta de Authorize.Net. Los verificamos con una pequeña autorización de prueba: tu registro de transacciones de Authorize.Net la muestra como un rechazo de $1.00, y no se mueve dinero. La cuenta debe estar en Modo en vivo, porque en Modo de prueba Authorize.Net rechaza todos los pagos reales.',
        hint: 'Encontrarás ambos en la Interfaz de Comerciante de Authorize.Net, en {{path}}.',
      },
      card_connect: {
        intro:
          'Introduzca el ID de comercio, el nombre de usuario y la contraseña de su cuenta activa de CardConnect (CardPointe). Las comprobamos con una autorización de 1,00 que anulamos de inmediato: el registro de transacciones de CardPointe la muestra como una de 1,00 rechazada o anulada, y no se mueve dinero.',
      },
      stripe_direct: {
        intro:
          'Pega la clave secreta de la cuenta de Stripe con la que debe cobrar cada restaurante. Configuramos el webhook que Stripe necesita por ti.',
        secret_key: 'Clave secreta de Stripe',
        hint: 'Stripe → Developers → API keys. Empieza con sk_. No se necesita la clave publicable.',
        prefix_error: 'Las claves secretas de Stripe empiezan con sk_.',
      },
      connected: {
        title: '{{name}} está conectado.',
        description:
          'Usaremos estas credenciales para todos tus restaurantes. Cada restaurante sigue añadiendo sus datos comerciales.',
      },
      errors: {
        generic: 'No pudimos conectar {{name}}',
      },
    },
    stripe: {
      title: 'Conectar Stripe Connect',
      rotate_title: 'Reemplazar tu clave de Stripe Connect',
      rotate_intro:
        'Pega una nueva clave secreta y una clave publicable de la misma cuenta de Stripe. Tus restaurantes seguirán conectados.',
      intro:
        'Pega la clave secreta y la clave publicable de tu cuenta de Stripe. Ambas están en Developers → API keys.',
      verify_and_connect: 'Verificar y conectar',
      checking: 'Comprobando con Stripe…',
      secret_key: {
        label: 'Clave secreta',
        hint: 'Stripe → Developers → API keys. Comienza con sk_.',
        prefix_error: 'Las claves secretas comienzan con sk_. Esto parece un tipo de clave diferente.',
      },
      restricted_key: {
        label: 'Clave de API restringida',
        hint: 'Stripe → Developers → API keys → Create restricted key. Empieza por rk_. Configúrala como se describe arriba.',
        prefix_error: 'Las claves restringidas empiezan con rk_. Esto parece ser un tipo de clave diferente.',
      },
      use_restricted_key: 'Usar una clave restringida en su lugar',
      use_secret_key: 'Usar la clave secreta en su lugar',
      publishable_key: {
        label: 'Clave publicable',
        hint: 'En la misma página de Stripe. Empieza con pk_. Tus tiendas la necesitan para aceptar tarjetas.',
        prefix_error: 'Las claves publicables empiezan con pk_.',
        mode_mismatch: 'Una de las claves es live y la otra es de prueba. Ambas deben ser del mismo modo de Stripe.',
      },
      name: {
        label: 'Nombra esta conexión',
        hint: 'Opcional. Se muestra donde sea que aparezca este proveedor.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Cómo crear esta clave',
        start_blank:
          'Cuando Stripe pregunte cómo usarás la clave, elige «{{option}}». Empieza con todos los permisos en {{none}}.',
        intro:
          'Después configura el interruptor de cada una de estas filas de sección. Establece todos los permisos de esa sección, así que no hace falta revisarlos uno por uno.',
        rows_checked: 'Comprobamos: {{rows}}',
        secret_key_hint: 'Deja todas las demás secciones en {{none}}. Una clave secreta no necesita nada de esto.',
        open_stripe: 'Abrir tus claves API de Stripe',
      },
      login_setting: {
        title: 'Desactiva el inicio de sesión de Stripe para tus restaurantes',
        description:
          'En tu Dashboard de Stripe, abre Configuración → Connect → Pagos → Cuentas externas y desactiva «{{setting}}». Mientras esté activada, Stripe obliga a cada restaurante a crear un inicio de sesión de Stripe con un número de teléfono durante el registro y le pide un código SMS en cada visita posterior, de modo que quien no tenga ese teléfono no puede continuar.',
        bank_details:
          'No se pierde nada: los restaurantes introducen sus datos bancarios en nuestro propio formulario.',
        open_stripe: 'Abrir este ajuste de Stripe',
      },
      errors: {
        generic: 'No se pudo contactar con Stripe',
      },
    },
    default_choice: {
      label: 'Usar como predeterminado para los restaurantes',
      hint: 'Los restaurantes nuevos y los que aún no tienen proveedor se vinculan a él automáticamente. Déjalo sin marcar para elegir tú mismo un proveedor para cada restaurante.',
    },
    manage: {
      payment_methods: 'Métodos de pago',
      edit_credentials: 'Editar credenciales',
      edit_credentials_unavailable: 'Editar credenciales (este proveedor no está disponible en este momento)',
      set_primary: 'Establecer como predeterminado para nuevos restaurantes',
      clear_primary: 'Dejar de usar como predeterminado para nuevos restaurantes',
      rename: {
        action: 'Renombrar conexión',
        title: 'Renombrar esta conexión',
        confirm: 'Guardar',
      },
      disconnect: {
        action: 'Desconectar',
        title: '¿Desconectar {{name}}?',
        confirm: 'Desconectar',
        warning_one: '{{count}} restaurante está vinculado a este y volverá a No configurado.',
        warning_other: '{{count}} restaurantes están vinculados a este y volverán a No configurado.',
        live: {
          title_one: 'Los pagos en línea se pausan para {{count}} restaurante activo',
          title_other: 'Los pagos en línea se pausan para {{count}} restaurantes activos',
          description:
            'En cuanto lo desconectes, sus clientes ya no podrán pagar en línea. Cada uno vuelve a Sin configurar hasta que lo vincules a otro proveedor.',
          refunds: 'Los pedidos ya pagados con este proveedor ya no se podrán reembolsar desde FoodAmigos.',
          pause_one: 'Pausar los pagos en línea de este restaurante',
          pause_other: 'Pausar los pagos en línea de estos {{count}} restaurantes',
          confirm: 'Desconectar y pausar los pagos',
        },
      },
      remove: {
        action: 'Quitar de la lista',
        title: '¿Quitar {{name}}?',
        description: 'Ya está desconectado y ningún restaurante lo usa. Dejará de aparecer en esta lista.',
        confirm: 'Quitar',
      },
    },
    payment_methods: {
      title: 'Métodos de pago para {{name}}',
      description:
        'Elige los métodos locales que tus restaurantes ofrecen a través de este proveedor. Cada uno se muestra solo donde coincide la moneda del restaurante.',
      save: 'Guardar',
      publishable_key: {
        label: 'Clave publicable de Stripe',
        hint: 'Stripe la necesita para mostrar el formulario de pago. Encuéntrala en tu panel de Stripe en Developers → API keys.',
        invalid: 'Una clave publicable aquí comienza con {{prefix}}.',
        clear_to_save:
          'Pertenece al otro modo de Stripe. Bórralo para guardar con todos los métodos locales desactivados.',
      },
      on_other_connection: 'ya activado para {{connection}}',
      other_currency: 'no disponible en {{currency}}',
      delivery_only: '{{name}} (solo pedidos con reparto: necesita la dirección del cliente)',
      invite_only:
        '{{name}} (Stripe lo ofrece solo por invitación: solicita acceso primero en tu panel de Stripe, o Stripe rechazará todos los pagos)',
      also_enable: {
        stripe:
          'Activa los mismos métodos en tu panel de Stripe en Settings → Payment methods, o Stripe los rechazará.',
        provider: 'Tu contrato con este proveedor debe incluir los métodos que actives aquí.',
        braintree:
          'Vincula PayPal y Venmo en tu Panel de Control de Braintree en Configuración → Procesamiento primero, o Braintree los rechazará. Venmo es para restaurantes de EE. UU. que cobran en dólares.',
        paypal_direct:
          'Los pagos de PayPal se abonan en esta cuenta empresarial de PayPal. Para Venmo, conecta Braintree.',
      },
    },
    actions: {
      cancel: 'Cancelar',
    },
    toasts: {
      load_error: 'No se pudieron cargar tus proveedores conectados',
      credentials_replaced: 'Credenciales reemplazadas',
      save_error: 'No se pudo guardar',
      connected: 'Stripe Connect está conectado',
      renamed: 'Conexión renombrada',
      primary_set: 'Proveedor predeterminado actualizado',
      primary_cleared:
        'Proveedor predeterminado eliminado. Los nuevos restaurantes no se vincularán a ningún proveedor hasta que elijas uno.',
      disconnected: 'Proveedor desconectado',
      removed: 'Proveedor quitado',
      payment_methods_saved: 'Métodos de pago guardados',
    },
  },
  restaurants: {
    title: 'Restaurantes',
    description: 'En qué punto está cada restaurante con los pagos en línea.',
    search: 'Buscar restaurantes',
    filters: {
      all: 'Todos ({{count}})',
      needs_attention: 'Necesitan atención ({{count}})',
    },
    empty: 'Aún no hay restaurantes.',
    empty_attention: 'Nada necesita tu atención.',
    columns: {
      restaurant: 'Restaurante',
      provider: 'Proveedor',
      status: 'Estado',
      action: 'Acción',
    },
    no_provider: '—',
    foodamigos_payments: 'Pagos de FoodAmigos',
    groups: {
      not_set_up: 'Sin configurar',
      business_details_missing: 'Faltan datos del negocio',
      hosted_not_finished: 'Formulario de {{provider}} sin terminar',
      hosted_not_finished_generic: 'Formulario del proveedor sin terminar',
      waiting_for_provider: 'Esperando al proveedor',
      action_needed: 'Necesita acción',
      payments_live: 'Pagos activos',
      online_payments_off: 'Pagos en línea desactivados',
      waiting_for_partner: 'Esperándote a ti',
    },
    link_expired: 'Enlace caducado',
    actions: {
      set_up: 'Configurar',
      change: 'Cambiar',
      unlink: 'Desvincular',
      remind: 'Recordar al propietario',
      reminded: 'Recordado · otra vez {{time}}',
    },
    assign: {
      title: '¿Qué proveedor debe usar {{name}}?',
      label: 'Proveedor',
      confirm: 'Guardar',
      cancel: 'Cancelar',
      primary: 'Predeterminado',
      none: 'Primero conecta un proveedor.',
    },
    unlink: {
      title: '¿Desvincular {{name}} de {{provider}}?',
      title_generic: '¿Desvincular {{name}} de su proveedor?',
      description:
        'El restaurante vuelve a «Sin configurar» para que puedas elegir el proveedor adecuado. El proveedor sigue conectado para tus otros restaurantes.',
      confirm: 'Desvincular',
    },
    pause: {
      title: 'Los pagos online se pausan para {{name}}',
      description:
        'Sus clientes ya no podrán pagar online hasta que el restaurante se configure y verifique de nuevo con un proveedor.',
      refunds: 'Los pedidos ya pagados con el proveedor actual ya no se podrán reembolsar desde FoodAmigos.',
      confirm: 'Pausar los pagos en línea de este restaurante',
    },
    toasts: {
      load_error: 'No se pudieron cargar tus restaurantes',
      assigned: 'Proveedor guardado',
      assign_error: 'No se pudo guardar el proveedor',
      unlinked: 'Restaurante desvinculado',
      unlink_error: 'No se pudo desvincular el restaurante',
      reminded: 'Recordatorio enviado al propietario',
      remind_error: 'No se pudo enviar el recordatorio',
      cooling_down: 'Ya se recordó al propietario hoy',
    },
  },
  footer: {
    text: 'Tu tarifa de servicio de FoodAmigos se te cobra sin importar qué proveedor use un restaurante.',
    link: 'Ver Facturación',
  },
};
